/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "features/growth/v3/tracking/page_view.proto" (package "fubo.tv.proto.features.growth.v3.tracking", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Error } from "../../../../common/v3/generic/error";
import { Growth } from "../../../../common/v3/generic/growth";
import { Location } from "../../../../common/v3/generic/location";
import { Channel } from "../../../../common/v3/generic/channel";
import { Asset } from "../../../../common/v3/generic/asset";
import { Genre } from "../../../../common/v3/generic/genre";
import { Team } from "../../../../common/v3/generic/team";
import { League } from "../../../../common/v3/generic/league";
import { Sport } from "../../../../common/v3/generic/sport";
import { Program } from "../../../../common/v3/generic/program";
import { Partner } from "../../../../common/v3/generic/partner";
import { Cohorting } from "../../../../common/v3/generic/cohorting";
import { SubGrowth } from "../../../../common/v3/generic/sub_growth";
import { Source } from "../../../../common/v3/generic/source";
import { Device } from "../../../../common/v3/generic/device";
import { Ui } from "../../../../common/v3/generic/ui";
import { Navigation } from "../../../../common/v3/generic/navigation";
import { AppContext } from "../../../../common/v3/generic/app_context";
import { UserProperties } from "../../../../common/v3/generic/user_properties";
import { FuboContext } from "../../../../common/v3/generic/fubo_context";
import { Core } from "../../../../common/v3/generic/core";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message fubo.tv.proto.features.growth.v3.tracking.PageView
 */
export interface PageView {
    /**
     * @generated from protobuf field: optional string anonymous_id = 1;
     */
    anonymous_id?: string;
    /**
     * @generated from protobuf field: fubo.tv.proto.features.growth.v3.tracking.PageView.EventName event = 2;
     */
    event: PageView_EventName;
    /**
     * @generated from protobuf field: string message_id = 3;
     */
    message_id: string;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp received_at = 4;
     */
    received_at?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp sent_at = 5;
     */
    sent_at?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 6;
     */
    timestamp?: Timestamp;
    /**
     * @generated from protobuf field: string type = 7;
     */
    type: string;
    /**
     * @generated from protobuf field: optional string user_id = 8;
     */
    user_id?: string;
    /**
     * @generated from protobuf field: fubo.tv.proto.features.growth.v3.tracking.PageView.Properties properties = 9;
     */
    properties?: PageView_Properties;
}
/**
 * @generated from protobuf message fubo.tv.proto.features.growth.v3.tracking.PageView.Attribute
 */
export interface PageView_Attribute {
    /**
     * @generated from protobuf field: optional fubo.tv.proto.features.growth.v3.tracking.PageView.Attribute.EventCategory.EventCategoryValue event_category = 1;
     */
    event_category?: PageView_Attribute_EventCategory_EventCategoryValue;
}
/**
 * @generated from protobuf message fubo.tv.proto.features.growth.v3.tracking.PageView.Attribute.EventCategory
 */
export interface PageView_Attribute_EventCategory {
}
/**
 * @generated from protobuf enum fubo.tv.proto.features.growth.v3.tracking.PageView.Attribute.EventCategory.EventCategoryValue
 */
export enum PageView_Attribute_EventCategory_EventCategoryValue {
    /**
     * @generated from protobuf enum value: acquisition_context = 0;
     */
    acquisition_context = 0,
    /**
     * @generated from protobuf enum value: p13n_acq_context = 1;
     */
    p13n_acq_context = 1
}
/**
 * @generated from protobuf message fubo.tv.proto.features.growth.v3.tracking.PageView.Properties
 */
export interface PageView_Properties {
    /**
     * @generated from protobuf field: fubo.tv.proto.common.v3.generic.Core core = 1;
     */
    core?: Core;
    /**
     * @generated from protobuf field: fubo.tv.proto.common.v3.generic.FuboContext fubo_context = 2;
     */
    fubo_context?: FuboContext;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.UserProperties user_properties = 3;
     */
    user_properties?: UserProperties;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.AppContext app_context = 4;
     */
    app_context?: AppContext;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Navigation navigation = 5;
     */
    navigation?: Navigation;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Ui ui = 6;
     */
    ui?: Ui;
    /**
     * @generated from protobuf field: fubo.tv.proto.common.v3.generic.Device device = 7;
     */
    device?: Device;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Source source = 8;
     */
    source?: Source;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.SubGrowth sub_growth = 9;
     */
    sub_growth?: SubGrowth;
    /**
     * @generated from protobuf field: repeated fubo.tv.proto.common.v3.generic.Cohorting cohorting = 10;
     */
    cohorting: Cohorting[];
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Partner partner = 11;
     */
    partner?: Partner;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Program program = 12;
     */
    program?: Program;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Sport sport = 13;
     */
    sport?: Sport;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.League league = 14;
     */
    league?: League;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Team team = 15;
     */
    team?: Team;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Genre genre = 16;
     */
    genre?: Genre;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Asset asset = 17;
     */
    asset?: Asset;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Channel channel = 18;
     */
    channel?: Channel;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Location location = 19;
     */
    location?: Location;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Growth growth = 20;
     */
    growth?: Growth;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.features.growth.v3.tracking.PageView.Attribute attribute = 21;
     */
    attribute?: PageView_Attribute;
    /**
     * @generated from protobuf field: optional fubo.tv.proto.common.v3.generic.Error error = 22;
     */
    error?: Error;
}
/**
 * @generated from protobuf enum fubo.tv.proto.features.growth.v3.tracking.PageView.EventName
 */
export enum PageView_EventName {
    /**
     * @generated from protobuf enum value: page_view = 0;
     */
    page_view = 0
}
// @generated message type with reflection information, may provide speed optimized methods
class PageView$Type extends MessageType<PageView> {
    constructor() {
        super("fubo.tv.proto.features.growth.v3.tracking.PageView", [
            { no: 1, name: "anonymous_id", kind: "scalar", localName: "anonymous_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "c6ced3d1-694c-4658-83a6-719f6cdcfb47", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "A pseudo-unique substitute for a User ID, for cases when you don\u2019t have an absolutely unique identifier, an anonymous_id or a user_id is required." } },
            { no: 2, name: "event", kind: "enum", T: () => ["fubo.tv.proto.features.growth.v3.tracking.PageView.EventName", PageView_EventName], options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "page_view", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Event name." } },
            { no: 3, name: "message_id", kind: "scalar", localName: "message_id", T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "6ac0e185-427b-40fb-b213-e624d0c1b3e0", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "A unique identifier for each message that lets you find an individual message across the API." } },
            { no: 4, name: "received_at", kind: "message", localName: "received_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Timestamp of receiving event in RFC 3339 format, enriched by Ingestion Backend" } },
            { no: 5, name: "sent_at", kind: "message", localName: "sent_at", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Timestamp of sending event in RFC 3339 format." } },
            { no: 6, name: "timestamp", kind: "message", T: () => Timestamp, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "2023-07-12T11:03:12+02:00", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Timestamp of event in RFC 3339 format." } },
            { no: 7, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "track", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Type of message, track or identify." } },
            { no: 8, name: "user_id", kind: "scalar", localName: "user_id", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "1234567891011", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Unique identifier for the user, an anonymous_id or a user_id is required." } },
            { no: 9, name: "properties", kind: "message", T: () => PageView_Properties }
        ], { "fubo.tv.proto.common.v3.custom.bigquery_opts": { tableName: "page_view" } });
    }
    create(value?: PartialMessage<PageView>): PageView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.event = 0;
        message.message_id = "";
        message.type = "";
        if (value !== undefined)
            reflectionMergePartial<PageView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PageView): PageView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string anonymous_id */ 1:
                    message.anonymous_id = reader.string();
                    break;
                case /* fubo.tv.proto.features.growth.v3.tracking.PageView.EventName event */ 2:
                    message.event = reader.int32();
                    break;
                case /* string message_id */ 3:
                    message.message_id = reader.string();
                    break;
                case /* optional google.protobuf.Timestamp received_at */ 4:
                    message.received_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.received_at);
                    break;
                case /* google.protobuf.Timestamp sent_at */ 5:
                    message.sent_at = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.sent_at);
                    break;
                case /* google.protobuf.Timestamp timestamp */ 6:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* string type */ 7:
                    message.type = reader.string();
                    break;
                case /* optional string user_id */ 8:
                    message.user_id = reader.string();
                    break;
                case /* fubo.tv.proto.features.growth.v3.tracking.PageView.Properties properties */ 9:
                    message.properties = PageView_Properties.internalBinaryRead(reader, reader.uint32(), options, message.properties);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PageView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string anonymous_id = 1; */
        if (message.anonymous_id !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.anonymous_id);
        /* fubo.tv.proto.features.growth.v3.tracking.PageView.EventName event = 2; */
        if (message.event !== 0)
            writer.tag(2, WireType.Varint).int32(message.event);
        /* string message_id = 3; */
        if (message.message_id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.message_id);
        /* optional google.protobuf.Timestamp received_at = 4; */
        if (message.received_at)
            Timestamp.internalBinaryWrite(message.received_at, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp sent_at = 5; */
        if (message.sent_at)
            Timestamp.internalBinaryWrite(message.sent_at, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp timestamp = 6; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string type = 7; */
        if (message.type !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.type);
        /* optional string user_id = 8; */
        if (message.user_id !== undefined)
            writer.tag(8, WireType.LengthDelimited).string(message.user_id);
        /* fubo.tv.proto.features.growth.v3.tracking.PageView.Properties properties = 9; */
        if (message.properties)
            PageView_Properties.internalBinaryWrite(message.properties, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.features.growth.v3.tracking.PageView
 */
export const PageView = new PageView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PageView_Attribute$Type extends MessageType<PageView_Attribute> {
    constructor() {
        super("fubo.tv.proto.features.growth.v3.tracking.PageView.Attribute", [
            { no: 1, name: "event_category", kind: "enum", localName: "event_category", opt: true, T: () => ["fubo.tv.proto.features.growth.v3.tracking.PageView.Attribute.EventCategory.EventCategoryValue", PageView_Attribute_EventCategory_EventCategoryValue], options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "acquisition_context", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "when user visits either a initial/final landing page or welcome page" } }
        ]);
    }
    create(value?: PartialMessage<PageView_Attribute>): PageView_Attribute {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PageView_Attribute>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PageView_Attribute): PageView_Attribute {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional fubo.tv.proto.features.growth.v3.tracking.PageView.Attribute.EventCategory.EventCategoryValue event_category */ 1:
                    message.event_category = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PageView_Attribute, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional fubo.tv.proto.features.growth.v3.tracking.PageView.Attribute.EventCategory.EventCategoryValue event_category = 1; */
        if (message.event_category !== undefined)
            writer.tag(1, WireType.Varint).int32(message.event_category);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.features.growth.v3.tracking.PageView.Attribute
 */
export const PageView_Attribute = new PageView_Attribute$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PageView_Attribute_EventCategory$Type extends MessageType<PageView_Attribute_EventCategory> {
    constructor() {
        super("fubo.tv.proto.features.growth.v3.tracking.PageView.Attribute.EventCategory", []);
    }
    create(value?: PartialMessage<PageView_Attribute_EventCategory>): PageView_Attribute_EventCategory {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PageView_Attribute_EventCategory>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PageView_Attribute_EventCategory): PageView_Attribute_EventCategory {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PageView_Attribute_EventCategory, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.features.growth.v3.tracking.PageView.Attribute.EventCategory
 */
export const PageView_Attribute_EventCategory = new PageView_Attribute_EventCategory$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PageView_Properties$Type extends MessageType<PageView_Properties> {
    constructor() {
        super("fubo.tv.proto.features.growth.v3.tracking.PageView.Properties", [
            { no: 1, name: "core", kind: "message", T: () => Core },
            { no: 2, name: "fubo_context", kind: "message", localName: "fubo_context", T: () => FuboContext },
            { no: 3, name: "user_properties", kind: "message", localName: "user_properties", T: () => UserProperties },
            { no: 4, name: "app_context", kind: "message", localName: "app_context", T: () => AppContext },
            { no: 5, name: "navigation", kind: "message", T: () => Navigation },
            { no: 6, name: "ui", kind: "message", T: () => Ui },
            { no: 7, name: "device", kind: "message", T: () => Device },
            { no: 8, name: "source", kind: "message", T: () => Source },
            { no: 9, name: "sub_growth", kind: "message", localName: "sub_growth", T: () => SubGrowth },
            { no: 10, name: "cohorting", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Cohorting },
            { no: 11, name: "partner", kind: "message", T: () => Partner },
            { no: 12, name: "program", kind: "message", T: () => Program },
            { no: 13, name: "sport", kind: "message", T: () => Sport },
            { no: 14, name: "league", kind: "message", T: () => League },
            { no: 15, name: "team", kind: "message", T: () => Team },
            { no: 16, name: "genre", kind: "message", T: () => Genre },
            { no: 17, name: "asset", kind: "message", T: () => Asset },
            { no: 18, name: "channel", kind: "message", T: () => Channel },
            { no: 19, name: "location", kind: "message", T: () => Location },
            { no: 20, name: "growth", kind: "message", T: () => Growth },
            { no: 21, name: "attribute", kind: "message", T: () => PageView_Attribute },
            { no: 22, name: "error", kind: "message", T: () => Error }
        ]);
    }
    create(value?: PartialMessage<PageView_Properties>): PageView_Properties {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cohorting = [];
        if (value !== undefined)
            reflectionMergePartial<PageView_Properties>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PageView_Properties): PageView_Properties {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* fubo.tv.proto.common.v3.generic.Core core */ 1:
                    message.core = Core.internalBinaryRead(reader, reader.uint32(), options, message.core);
                    break;
                case /* fubo.tv.proto.common.v3.generic.FuboContext fubo_context */ 2:
                    message.fubo_context = FuboContext.internalBinaryRead(reader, reader.uint32(), options, message.fubo_context);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.UserProperties user_properties */ 3:
                    message.user_properties = UserProperties.internalBinaryRead(reader, reader.uint32(), options, message.user_properties);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.AppContext app_context */ 4:
                    message.app_context = AppContext.internalBinaryRead(reader, reader.uint32(), options, message.app_context);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Navigation navigation */ 5:
                    message.navigation = Navigation.internalBinaryRead(reader, reader.uint32(), options, message.navigation);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Ui ui */ 6:
                    message.ui = Ui.internalBinaryRead(reader, reader.uint32(), options, message.ui);
                    break;
                case /* fubo.tv.proto.common.v3.generic.Device device */ 7:
                    message.device = Device.internalBinaryRead(reader, reader.uint32(), options, message.device);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Source source */ 8:
                    message.source = Source.internalBinaryRead(reader, reader.uint32(), options, message.source);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.SubGrowth sub_growth */ 9:
                    message.sub_growth = SubGrowth.internalBinaryRead(reader, reader.uint32(), options, message.sub_growth);
                    break;
                case /* repeated fubo.tv.proto.common.v3.generic.Cohorting cohorting */ 10:
                    message.cohorting.push(Cohorting.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Partner partner */ 11:
                    message.partner = Partner.internalBinaryRead(reader, reader.uint32(), options, message.partner);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Program program */ 12:
                    message.program = Program.internalBinaryRead(reader, reader.uint32(), options, message.program);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Sport sport */ 13:
                    message.sport = Sport.internalBinaryRead(reader, reader.uint32(), options, message.sport);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.League league */ 14:
                    message.league = League.internalBinaryRead(reader, reader.uint32(), options, message.league);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Team team */ 15:
                    message.team = Team.internalBinaryRead(reader, reader.uint32(), options, message.team);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Genre genre */ 16:
                    message.genre = Genre.internalBinaryRead(reader, reader.uint32(), options, message.genre);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Asset asset */ 17:
                    message.asset = Asset.internalBinaryRead(reader, reader.uint32(), options, message.asset);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Channel channel */ 18:
                    message.channel = Channel.internalBinaryRead(reader, reader.uint32(), options, message.channel);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Location location */ 19:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Growth growth */ 20:
                    message.growth = Growth.internalBinaryRead(reader, reader.uint32(), options, message.growth);
                    break;
                case /* optional fubo.tv.proto.features.growth.v3.tracking.PageView.Attribute attribute */ 21:
                    message.attribute = PageView_Attribute.internalBinaryRead(reader, reader.uint32(), options, message.attribute);
                    break;
                case /* optional fubo.tv.proto.common.v3.generic.Error error */ 22:
                    message.error = Error.internalBinaryRead(reader, reader.uint32(), options, message.error);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PageView_Properties, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* fubo.tv.proto.common.v3.generic.Core core = 1; */
        if (message.core)
            Core.internalBinaryWrite(message.core, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* fubo.tv.proto.common.v3.generic.FuboContext fubo_context = 2; */
        if (message.fubo_context)
            FuboContext.internalBinaryWrite(message.fubo_context, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.UserProperties user_properties = 3; */
        if (message.user_properties)
            UserProperties.internalBinaryWrite(message.user_properties, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.AppContext app_context = 4; */
        if (message.app_context)
            AppContext.internalBinaryWrite(message.app_context, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Navigation navigation = 5; */
        if (message.navigation)
            Navigation.internalBinaryWrite(message.navigation, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Ui ui = 6; */
        if (message.ui)
            Ui.internalBinaryWrite(message.ui, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* fubo.tv.proto.common.v3.generic.Device device = 7; */
        if (message.device)
            Device.internalBinaryWrite(message.device, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Source source = 8; */
        if (message.source)
            Source.internalBinaryWrite(message.source, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.SubGrowth sub_growth = 9; */
        if (message.sub_growth)
            SubGrowth.internalBinaryWrite(message.sub_growth, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated fubo.tv.proto.common.v3.generic.Cohorting cohorting = 10; */
        for (let i = 0; i < message.cohorting.length; i++)
            Cohorting.internalBinaryWrite(message.cohorting[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Partner partner = 11; */
        if (message.partner)
            Partner.internalBinaryWrite(message.partner, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Program program = 12; */
        if (message.program)
            Program.internalBinaryWrite(message.program, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Sport sport = 13; */
        if (message.sport)
            Sport.internalBinaryWrite(message.sport, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.League league = 14; */
        if (message.league)
            League.internalBinaryWrite(message.league, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Team team = 15; */
        if (message.team)
            Team.internalBinaryWrite(message.team, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Genre genre = 16; */
        if (message.genre)
            Genre.internalBinaryWrite(message.genre, writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Asset asset = 17; */
        if (message.asset)
            Asset.internalBinaryWrite(message.asset, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Channel channel = 18; */
        if (message.channel)
            Channel.internalBinaryWrite(message.channel, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Location location = 19; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Growth growth = 20; */
        if (message.growth)
            Growth.internalBinaryWrite(message.growth, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.features.growth.v3.tracking.PageView.Attribute attribute = 21; */
        if (message.attribute)
            PageView_Attribute.internalBinaryWrite(message.attribute, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* optional fubo.tv.proto.common.v3.generic.Error error = 22; */
        if (message.error)
            Error.internalBinaryWrite(message.error, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.features.growth.v3.tracking.PageView.Properties
 */
export const PageView_Properties = new PageView_Properties$Type();
